export default __webpack_public_path__ + "static/media/findBetterYou.8fa749ea.svg";